var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDigitalRiskProtection = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    className: "fill",
    viewBox: "0 0 16 18.286",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3.416 8 1.56 1.5 3.416v5.727c0 2.015 1.506 3.913 3.438 5.458A20 20 0 0 0 8 16.605a20 20 0 0 0 3.063-2.004c1.93-1.545 3.437-3.443 3.437-5.458zM16 9.143c0 5.485-8 9.143-8 9.143l-.344-.168C6.126 17.343 0 13.943 0 9.143V2.285L8 0l7.999 2.285.001.001z"
  })));
};
export default SvgDigitalRiskProtection;